"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObidiahsBurningIncantationAbilityHandler = exports.ObidiahsBurningIncantationActorAbilityFactory = exports.ObidiahsBurningIncantationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Burning_1 = require("../../core/effects/core/Burning");
const ObidiahsBlessing_1 = require("../../core/effects/core/ObidiahsBlessing");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ObidiahsBurningIncantationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ObidiahsBurningIncantation;
        this.__typeName = "ObidiahsBurningIncantation";
    }
}
exports.ObidiahsBurningIncantationAbilityArgs = ObidiahsBurningIncantationAbilityArgs;
let ObidiahsBurningIncantationActorAbilityFactory = class ObidiahsBurningIncantationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ObidiahsBurningIncantation", "OneEnemies", 0);
    }
};
ObidiahsBurningIncantationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ObidiahsBurningIncantation")
], ObidiahsBurningIncantationActorAbilityFactory);
exports.ObidiahsBurningIncantationActorAbilityFactory = ObidiahsBurningIncantationActorAbilityFactory;
let ObidiahsBurningIncantationAbilityHandler = class ObidiahsBurningIncantationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 100)
            ],
            projectileType: "MagicSpear",
            projectilePath: "line",
            onHit(sequence) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "BlueFlameStrike"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new ObidiahsBlessing_1.ObidiahsBlessingEffectArgs(),
                        new Burning_1.BurningEffectArgs("Focus", 10),
                    ], false)
                });
            }
        });
    }
};
ObidiahsBurningIncantationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ObidiahsBurningIncantation)
], ObidiahsBurningIncantationAbilityHandler);
exports.ObidiahsBurningIncantationAbilityHandler = ObidiahsBurningIncantationAbilityHandler;
